import { render, staticRenderFns } from "./FactsEdit.vue?vue&type=template&id=77dbc4e6&scoped=true&"
import script from "./FactsEdit.vue?vue&type=script&lang=js&"
export * from "./FactsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dbc4e6",
  null
  
)

export default component.exports